import React, { Component } from 'react';
import img from '../images/logo.png';
import { withRouter } from 'react-router-dom';
import { Button } from 'react-bootstrap';
import noty from './Noty';
import Logger from './Logger';
import "../../node_modules/noty/lib/noty.css";
import "../../node_modules/noty/lib/themes/bootstrap-v4.css";
import Cookies from 'universal-cookie';
import queryString from 'query-string';

const cookies = new Cookies();

function ErrorMsgBlock(props) {
  console.log(props)
  if (props.msgDisplay) {
    return (
      <div className="pin-error-block">
        <span className="wrong-pin">Please Enter Correct PIN !</span>
      </div>
    );
  } else {
    return <div />
  }
}

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showErrorMsg: false,
      mainHub: props.hub,
      pin: '',
      queryString: queryString.parse(props.location.search)
    }
    this.proceed = this.proceed.bind(this);
    this.routeChange = this.routeChange.bind(this);
    this.handleKeyPress = this.handleKeyPress.bind(this);
    this.handleChange = this.handleChange.bind(this);
  }

  componentDidMount() {
    document.addEventListener("keydown", this.handleKeyPress);
  }

  componentWillUnmount() {
    this.props.history.goForward();
    document.removeEventListener("keydown", this.handleKeyPress);
  }

  handleKeyPress = (event) => {
    if (event.which === 13) {
      this.proceed();
    }
  }

  handleChange(e) {
    this.setState({ pin: e.target.value });
  }

  checkCookies(pin) {
    let cookie = cookies.get('SimCookie');
    if (cookie == undefined || (cookie != undefined && !cookie.includes(pin))) {
      return true;
    } else {
      return false;
    }
  }

  proceed() {
    var self = this;
    const { mainHub, queryString } = self.state;
    let pin = self.state.pin;
    if (this.checkCookies(pin)) {
      if (parseInt(pin) == pin && pin.length == 4) {
        mainHub.invoke('JoinSim', pin)
          .then(function (response) {
            const result = JSON.parse(response);
            if (result.StatusCode !== "403")
              self.routeChange(response);
            else
              noty('error', 'Simulation does not exist.')
          })
          .catch(function (error) {
            noty('error', 'Something went wrong.')
            Logger('Join Simulation failed', error.message, error.stack, 'Error');
          });
      }
      else if (pin.trim().length == 0 && !queryString.code) {
        noty('error', 'Please enter PIN.')
      }
      else if(queryString.code != undefined){
        mainHub.invoke('InitSim', queryString.code)
          .then(function (response) {
            const result = JSON.parse(response);
            if (result.StatusCode !== "403"){
              self.routeChange(response);
            }
            else if (result.Message && result.Message != ''){
              noty('error', result.Message)
            }
            else{
              noty('error', 'Simulation does not exist.')
            }
          })
          .catch(function (error) {
            noty('error', 'Something went wrong.')
            Logger('Join Simulation failed', error.message, error.stack, 'Error');
          });
      }
      else {
        noty('error', 'You entered an invalid PIN.')
      }
    }
    else {
      noty('error', 'You cannot join this simulation, you already left earlier.')
    }
    
  }

  routeChange(data) {
    const path = `roles`;
    const {PortalSimulationId, Token, CreatedBy, Title, SimulationId, UserId, Pin} = JSON.parse(data);
    this.props.history.push(
      {
        pathname: path,
        state: {
          id: PortalSimulationId,
          token: Token,
          createdBy: CreatedBy,
          title: Title,
          simulationID: SimulationId,
          userId: UserId,
          pin: Pin,
          isMultiSimulationAllow: this.state.queryString.code ? true : false
        }
      }
    );
  }

  render() {
    const isDcrGraphId = this.state.queryString.code;
    const submitBtnCSS = isDcrGraphId ? "btn BtnStyle form-control mt-5" : "btn BtnStyle form-control"; 
    return (
      <div>
        <header>
        </header>
        <main>
          <div className="container main-pin-block">
            <div className="logo-block">
              <img src={img} className="logo" alt="logo" />
              <div className="logo-title-block"><span>DCR Solutions</span></div>
            </div>
            <ErrorMsgBlock msgDisplay={this.state.showErrorMsg} />
            {!isDcrGraphId && <div className="form-group">
              <input className="form-control" value={this.state.pin} maxLength='4' onChange={this.handleChange} id="pinId" placeholder="PIN" />
            </div>}
            <div className="form-group">
              <Button type="button" className={submitBtnCSS} onClick={this.proceed}>{!isDcrGraphId ? 'ENTER' : 'SIMULATE'}</Button>
            </div>
          </div>
        </main>
        <footer>

        </footer>
      </div>
    );
  }
}
export default withRouter(Login);
